module.exports = __webpack_public_path__ + "img/method_mob.png";